import React from 'react';
import PropTypes from 'prop-types';
import {
    Card,
    CardActionArea,
    CardContent,
} from '@mui/material';
import { trakrefFontFamilySemiBold } from '../utils';
import { Grey1 } from '../color_utils';

const MenuButton = ({
    icon,
    title,
    onClick,
    imageStyle={ width: 62, height: 62, margin: "0% auto" },
}) => (
    <Card
        variant="outlined"
        sx={{
            flexBasis: "31%",
            width: 370,
            height: 140
        }}
    >
        <CardActionArea
            onClick={onClick}
            sx={{
                ":focus": {
                    outline: "none"
                },
                height: 140
            }}
        >
            <CardContent>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center"
,                   flexDirection: "column",
                    marginBottom: "10px",
                    gap: "0px"

                }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        alignItems: "center",
                        width: 62,
                        height: 62}}
                    >
                            <img src={icon} style={imageStyle} />

                    </div>

                    <span
                        style={{
                            fontFamily: trakrefFontFamilySemiBold,
                            color: Grey1,
                            fontSize: '1.063rem',
                            textAlign: 'center',
                            padding: "0px",
                        }}
                    >
                        {title}
                    </span>
                </div>
            </CardContent>
        </CardActionArea>
    </Card>
);

MenuButton.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default MenuButton;
